import { render, staticRenderFns } from "./AcceptedChangePhantom.vue?vue&type=template&id=74668304&scoped=true&"
import script from "./AcceptedChangePhantom.vue?vue&type=script&lang=js&"
export * from "./AcceptedChangePhantom.vue?vue&type=script&lang=js&"
import style0 from "./AcceptedChangePhantom.vue?vue&type=style&index=0&id=74668304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74668304",
  null
  
)

export default component.exports